import React, { useEffect, useRef } from "react"
import Lottie from "lottie-web"
import Illustration from "./images/home_csi_anim.json"

const LogoIllustration = () => {
  const container = useRef(null)
  useEffect(() => {
    Lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: Illustration
    })
  }, [])

  return <div className="gif_container" ref={container} />
}

export default LogoIllustration
